'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LineRipple = undefined;

var _Base = require('../Base');

var LineRipple = exports.LineRipple = (0, _Base.simpleTag)({
  displayName: 'LineRipple',
  classNames: 'mdc-line-ripple'
});

exports.default = LineRipple;



//////////////////
// WEBPACK FOOTER
// ./node_modules/rmwc/LineRipple/index.js
// module id = 768
// module chunks = 0